export default __webpack_public_path__ + "media/images/ui-bg_diagonals-thick_18_b81900_40x40-aeb4e9cb65dc390a7596d0f9a7372db2.png";